/*----------------------------------
- ROUTE: /tld/:tld
----------------------------------*/

/**
 * @docs docs/features/tld-intelligence
 * @adr  ADR-0054
 */

/*----------------------------------
- DEPENDENCIES
----------------------------------*/

import { definePageRoute } from '@common/router/definitions';

import { buildTldInsightRouteData, renderTldInsightRoute } from './lib/insightRoute';

/*----------------------------------
- PAGE
----------------------------------*/

// One page per public-set TLD, published by `DomainsWarmup` like the `/domains` listings (no
// `static` option here: the warmup renders and evicts it). `applications` is the applications
// list's own path, with or without its trailing slash (this route outranks it), and the
// character class keeps `/tld/<slug>.md` for the Markdown route.
export default definePageRoute({
    path: '/tld/:tld((?!applications/?$)[a-z0-9-]+)',
    options: { auth: false, layout: false, priority: 20 },
    data: buildTldInsightRouteData,
    render: renderTldInsightRoute,
});
